import * as React from "react";
import { OpenAPI } from "../../../services/openapi";


export const downloadFile = (id: string, filename: string, onDone?: () => void) => {
    let url = "" + OpenAPI.BASE + "/doc/getFile/?id=" + encodeURIComponent(id);

    fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    })
      .then((result) => {
        if (result.status != 200) {
          throw new Error("Bad server response");
        }
        return result.blob();
      })
      .then((data: Blob | null) => {
        if (data !== null) {
          var url = URL.createObjectURL(data),
            anchor = document.createElement("a");
          anchor.href = url;
          let saveas = filename ? filename : "Datei.pdf";
          anchor.download = saveas;
          document.body.append(anchor);
          anchor.click();
          URL.revokeObjectURL(url);
          document.body.removeChild(anchor);
        }
        data = null;
        onDone?.();
      })
      .catch((error) => {
        console.log(error);
        onDone?.();
      });
  };


export const downloadFolder = (id: string, filename: string, onDone?: () => void) => {
    let url = "" + OpenAPI.BASE + "/doc/Files/download?id=" + encodeURIComponent(id);

    fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    })
      .then((result) => {
        if (result.status != 200) {
          throw new Error("Bad server response");
        }
        return result.blob();
      })
      .then((data) => {
        var url = URL.createObjectURL(data),
          anchor = document.createElement("a");
        anchor.href = url;
        let saveas = filename ? (filename + ".zip") : "Ordner.zip";
        anchor.download = saveas;
        document.body.append(anchor);
        anchor.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(anchor);
        onDone?.();
      })
      .catch((error) => {
        console.log(error);
        onDone?.();
      });
  };
